/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    import IUserGroup = Models.IUserGroup;

    export interface IAdminGroupModalScope extends ng.IScope {
        title: string;
        group: IUserGroup;
        modalClose: () => void;
        modalSave: () => void;
    }

    export class AdminGroupModalController {
        public static templateURL: string = "decorators/modals/admin-group-modal.html";
        public static ID: string = "#admin-group-modal";
        public static $name: string = "adminGroupModalController";
        public static $inject: string[] = ['$scope', 'close', '$timeout', 'title', 'group'];

        private $scope: IAdminGroupModalScope;
        private close: (parameters: ngModal.ICloseParameters) => void;

        /**
         * Constructor
         */
        constructor($scope: IAdminGroupModalScope,
                    close: (parameters: ngModal.ICloseParameters) => void,
                    $timeout: ng.ITimeoutService,
                    title: string,
                    group: IUserGroup) {
            $timeout(() => {
                window.altair_forms_validation();
            }, 500);
            this.$scope = $scope;
            this.close = close;
            this.$scope.title = title;
            this.$scope.group  = group;

            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.$scope.modalSave = (): void => {
                if (this.$scope.group.name && this.$scope.group.name !== '' &&
                    this.$scope.group.description && this.$scope.group.description !== '')
                    this.close(this.$scope.group);
            };
        }
    }
}
